





































































































































import { CognitoIdentityServiceProvider } from 'aws-sdk'
import fetch from 'node-fetch'
import VueCookies from 'vue-cookies'
import * as PolicyHelper from '../util/PasswordPolicy'
import { Component, Vue } from 'vue-property-decorator'

Vue.use(VueCookies)

Vue.directive('click', {
  inserted: el => {
    el.click()
  }
})

@Component
export default class Login extends Vue {
    // existing user
    private email = ''
    private password = ''
    private passwordErrors: string[] = []
    private passwordSuccesses: string[] = []

    // pending password reset
    private passwordResetRequired = false
    private passwordReset = ''
    private passwordResetConfirm = ''
    private passwordRequirements = ''
    private passwordPolicy: CognitoIdentityServiceProvider.PasswordPolicyType = {}
    private passwordResetErrors: string[] = []

    private protocol: string = Vue.prototype.$secureCookies ? 'https' : 'http'
    private protocolApi: string = Vue.prototype.$secureApi ? 'https' : 'http'
    // props
    // @Prop({ type: Boolean, required: true }) secureCookies!: boolean

    private disabled = false

    // methods
    public async signIn (): Promise<void> {
      try {
        this.passwordErrors = []
        this.passwordResetErrors = []
        this.passwordSuccesses = []
        if (this.passwordReset !== '') {
          PolicyHelper.ConformToPolicy(this.passwordPolicy, this.passwordReset, this.passwordResetConfirm)
        }
        this.disabled = true
        const resultsPromise = fetch(`${this.protocolApi}://${Vue.prototype.$hostApi}/api/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: this.email,
            password: this.password,
            passwordReset: this.passwordReset,
            passwordResetConfirm: this.passwordResetConfirm
          })
        })
        const results = await resultsPromise
        const resultsJson = await results.json()
        this.disabled = false
        if (resultsJson.passwordIncorrect) {
          this.passwordErrors.push('Incorrect username or password.')
        } else {
          if (resultsJson && resultsJson.passwordResetRequired) {
            this.passwordResetRequired = true
            return
          } else {
            this.passwordResetRequired = false
          }
          if (resultsJson.session) {
            await this.$router.push({
              name : 'MFA',
              params: {
                session: resultsJson.session,
                phoneNumber: resultsJson.phoneNumber,
                email: this.email
              }
            })
            return
          }
          // domain should be '.fusionware.com' in production use
          // you can only set cookies as secure if using HTTPS
          Vue.$cookies.config('7d', '/', Vue.prototype.$domain, Vue.prototype.$secureCookies)
          Vue.$cookies.set('accessToken', resultsJson.accessToken)
          Vue.$cookies.set('idToken', resultsJson.idToken)
          Vue.$cookies.set('refreshToken', resultsJson.refreshToken)

          const accessTokenB64 = resultsJson.accessToken.split('.')[1]
          const idTokenB64 = resultsJson.idToken.split('.')[1]
          const accessTokenDecoded = JSON.parse(window.atob(accessTokenB64))
          const idTokenDecoded = JSON.parse(window.atob(idTokenB64))
          const customers: string[] = accessTokenDecoded['cognito:groups'].filter((el: string) => el !== 'Admin')
          const isAdmin: boolean = accessTokenDecoded['cognito:groups'].filter((el: string) => el === 'Admin').length > 0
          let customerRedirect: number | null = null

          if (isAdmin && this.passwordErrors.length === 0) {
            customerRedirect = +idTokenDecoded['custom:current_customer']
          } else {
            customerRedirect = +customers[0]
          }
          let url = this.$route.query.url
          if (url && typeof url === 'string') {
            const goodDomain = await fetch(`${this.protocolApi}://${Vue.prototype.$centralApi}/domain/valid-redirect?domain=${url}`, {
              method: 'GET',
              headers: {
                'X-Id': resultsJson.idToken,
                Authorization: `Token ${resultsJson.accessToken}`
              }
            })
            if (goodDomain.ok) {
              try {
                if (!url.includes('://')) {
                  url = `${this.protocol}://${url}`
                }
                window.location.href = url
                return
              } catch (err) {
                this.passwordErrors.push('Url not valid')
                return
              }
            }
          }
          const customerResp = await fetch(`${this.protocolApi}://${Vue.prototype.$centralApi}/customer/${customerRedirect}`, {
            method: 'GET',
            headers: {
              'X-Id': resultsJson.idToken,
              Authorization: `Token ${resultsJson.accessToken}`
            }
          })
          try {
            const { subdomain: customerSubdomain } = await customerResp.json()
            window.location.href = `${this.protocol}://${customerSubdomain}${Vue.prototype.$domain}${Vue.prototype.$customerPort ? ':' + Vue.prototype.$customerPort : ''}/#/dashboard`
          } catch (err) {
            this.passwordErrors.push('You are now logged in but your associated subdomain was not found.')
          }
        }
      } catch (err: any) {
        this.disabled = false
        if (err instanceof PolicyHelper.PasswordResetError) {
          this.passwordResetErrors.push(err.toString())
        }
      }
    }

    public async created (): Promise<void> {
      const reAuth = this.$route.query.reauth_required === 'true'
      const policy = await PolicyHelper.GetPasswordPolicy(`${this.protocolApi}://${Vue.prototype.$hostApi}`)
      this.passwordRequirements = PolicyHelper.BuildPolicySentence(policy)
      this.passwordPolicy = policy
      if (reAuth) {
        this.passwordErrors.push('You must log in first.')
      }
    }

    get loginContainerStyle (): object {
      return this.passwordResetRequired ? { height: '100%' } : {}
    }
}
